import React from 'react';
import PropTypes from 'prop-types';
import * as localization from '@happylife-a/localization';
import { Icon } from '@chakra-ui/react';
import { theme } from '../../theme';

// Map locale codes to flag icon components
// This mapping uses locale constants from @happylife-a/localization
const FLAG_ICONS = {
  [localization.LOCALE_EN]: theme.icons.FlagIconEnglish,
  [localization.LOCALE_HY]: theme.icons.FlagIconArmenian,
  [localization.LOCALE_RU]: theme.icons.FlagIconRussian,
  [localization.LOCALE_UZ]: theme.icons.FlagIconUzbekistan,
};

/**
 * LanguageFlag - Reusable component for displaying language flag icons
 * @param {string} locale - Language code from @happylife-a/localization (e.g., LOCALE_EN, LOCALE_HY, LOCALE_RU, LOCALE_UZ)
 * @param {string|number} w - Width (default: "25px")
 * @param {string|number} h - Height (default: "18px")
 * @param {string} borderRadius - Border radius (optional)
 * @param {object} ...props - Additional props to pass to Icon
 */
export default function LanguageFlag({ locale, w = '25px', h = '18px', borderRadius, ...props }) {
  const FlagIcon = FLAG_ICONS[locale];

  if (!FlagIcon) {
    return null;
  }

  return <Icon as={FlagIcon} w={w} h={h} borderRadius={borderRadius} {...props} />;
}

LanguageFlag.propTypes = {
  locale: PropTypes.string.isRequired,
  w: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  h: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  borderRadius: PropTypes.string,
};
